//13、吊轮孔列 
import makerjs from "makerjs";
// inputParam,model,myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function HangWheelHoleCol(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut,cutLine,cutFilletRadius){
var D=inputParam.D,H=inputParam.H,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
plate = model.plate, cutPlate = model.cutPlate, markers = model.markers,
glassW=outParam.glassW,glassH=outParam.glassH,
   markShift=fixedParam.markShift*1,markShiftTwo=fixedParam.markShiftTwo*1,
   markShiftThree=fixedParam.markShiftThree*1,markShiftFour=fixedParam.markShiftFour*1,markHolesOneD=fixedParam.markHolesOneD*1,
 
   d = D*1*myZoom,
   h= H*1*myZoom,
     x0 = X*1*myZoom,
     y0 = Y*1*myZoom;
     /*
     d = D*1,
     h= H*1,
       x0 = X*1,
       y0 = Y*1;
       */
       if(plate.models===undefined||plate.models===""){
            console.log("1111111111111111");
            plate.models={};
                    }        
                    if(cutPlate.models===undefined||cutPlate.models===""){
                        console.log("22222222222");
                        //cutPlate.models={};
                        cutPlate.models={};
                    }
                    if(markers.models===undefined||markers.models===""){            
                        console.log("333333333333");
                        markers.models={};
                    }
     if(d!==0){
      var TxtD="∮"+D;
     }
     if(h!==0){
      var TxtH=H;
     }
     if(x0!==0){          
     var TxtX=X;
     }
     if(y0!==0){          
      var TxtY=Y;
     }
  //在A区域 计算孔的位置       
  var xa=x0,ya=glassH * 1-y0,
  //B区域//只有Y标注没有X标注 
  xb=glassW * 1/2,yb=glassH * 1-y0,
  //C区域
  xc=glassW * 1-x0,yc=glassH * 1-y0,
  //D区域
  //只有X标注没有Y标注 
  xd=x0,yd=glassH * 1/2,
  //E区域
  //只有X标注没有Y标注 
  xe=glassW * 1/2,ye=glassH * 1/2,
  //F区域
  //只有X标注没有Y标注 
  xf=glassW * 1-x0,yf=glassH * 1/2,
  //在G区域 计算孔的位置
  xg=x0,yg=y0,
  //在H区域 计算孔的位置
  //只标注Y
  xh=glassW*1/2,yh=y0,
  //在I区域 计算孔的位置
  xi=glassW*1-x0,yi=y0;
  if(glassW*1>glassH * 1){
      console.log("长边在X轴￥￥￥￥￥");
      if(area==1){
            //画孔 A位置孔
                  //标记吊轮孔列 A位置孔上
                  var myHwhcHolesAup= new makerjs.models.Holes(d/2, [[xa, ya]]);
                  var myHwhcHolesMarkAup = new makerjs.models.Square(0); //孔的原点       
                  myHwhcHolesMarkAup.origin = [xa, ya];      
                  var myHwhcHolesXMarkAup = new makerjs.models.Square(0);      
                  myHwhcHolesXMarkAup.origin =[xa, ya];      
                  var myHwhcHolesYMarkAup = new makerjs.models.Square(0);      
                  myHwhcHolesYMarkAup.origin = [xa, ya];  
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkAup, new makerjs.paths.Line([-x0,y0], [-x0, y0+markShiftTwo]));//Y轴加长标线
            makerjs.model.addPath(myHwhcHolesMarkAup, new makerjs.paths.Line([0,0], [-x0-markShiftThree, 0]));//从孔圆心出发X方向横向标线
            makerjs.model.addPath(myHwhcHolesMarkAup, new makerjs.paths.Line([-x0,y0], [-x0-markShiftThree, y0]));//X轴加长标线
            makerjs.model.addPath(myHwhcHolesMarkAup, new makerjs.paths.Line([0,0], [0, y0+markShiftTwo]));//从孔圆心出发Y方向竖向标线
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkAup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
            makerjs.model.addCaption(myHwhcHolesMarkAup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
            /*****************************************************************************/   
            makerjs.model.addPath(myHwhcHolesXMarkAup, new makerjs.paths.Line([0,y0+markShift], [-x0, y0+markShift]));//X短标线
            makerjs.model.addCaption(myHwhcHolesXMarkAup, TxtX, [-x0,y0+markShiftTwo], [0, y0+markShiftTwo]);//X文字标注
            /*****************************************************************************/     
            makerjs.model.addPath(myHwhcHolesYMarkAup, new makerjs.paths.Line([-x0-markShiftTwo,0], [-x0-markShiftTwo, y0]));//Y短标线
            makerjs.model.addCaption(myHwhcHolesYMarkAup, TxtY, [-x0-markShiftThree,0], [-x0-markShiftThree, y0]);//Y文字标注
            /*****************************************************************************/ 
             //标记吊轮孔列 A位置孔下
             var myHwhcHolesAdn= new makerjs.models.Holes(d/2, [[xa+h, ya]]);
                  var myHwhcHolesMarkAdn = new makerjs.models.Square(0); //孔的原点       
                  myHwhcHolesMarkAdn.origin = [xa+h, ya];       
                  var myHwhcHolesYMarkAdn = new makerjs.models.Square(0);      
                  myHwhcHolesYMarkAdn.origin = [xa+h, ya];  
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkAdn, new makerjs.paths.Line([0,0], [0, y0]));//从孔圆心出发X方向横向标线
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkAdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
            makerjs.model.addCaption(myHwhcHolesMarkAdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
            /*****************************************************************************/   
            makerjs.model.addPath(myHwhcHolesYMarkAdn, new makerjs.paths.Line([-h,0], [0, 0]));//Y短标线
            makerjs.model.addCaption(myHwhcHolesYMarkAdn, TxtH, [-h,0+markShift], [0, 0+markShift]);//Y文字标注
            /*****************************************************************************/ 
            plate.models["TypeHoles_HangWheelHoleCol_Aup"+myHolesNum]=myHwhcHolesAup;
            cutPlate.models["TypeHoles_HangWheelHoleCol_Aup"+myHolesNum]=myHwhcHolesAup;
            markers.models["TypeHoles_HangWheelHoleCol_Aup"+myHolesNum]=myHwhcHolesAup;
            markers.models["TypeHoles_HangWheelHoleCol_MarkAup"+myHolesNum]=myHwhcHolesMarkAup;
            markers.models["TypeHoles_HangWheelHoleCol_XMarkAup"+myHolesNum]=myHwhcHolesXMarkAup;
            markers.models["TypeHoles_HangWheelHoleCol_YMarkAup"+myHolesNum]=myHwhcHolesYMarkAup;
            /*****************************************************************************/
            plate.models["TypeHoles_HangWheelHoleCol_Adn"+myHolesNum]=myHwhcHolesAdn;
            cutPlate.models["TypeHoles_HangWheelHoleCol_Adn"+myHolesNum]=myHwhcHolesAdn;
            markers.models["TypeHoles_HangWheelHoleCol_Adn"+myHolesNum]=myHwhcHolesAdn;
            markers.models["TypeHoles_HangWheelHoleCol_MarkAdn"+myHolesNum]=myHwhcHolesMarkAdn;
            markers.models["TypeHoles_HangWheelHoleCol_YMarkAdn"+myHolesNum]=myHwhcHolesYMarkAdn;
            /*****************************************************************************/ 
               
            }else if(area==4){
            //画孔 D位置孔
                  //标记吊轮孔列D位置孔上
                  var myHwhcHolesDup= new makerjs.models.Holes(d/2, [[xd, yd]]);
                  var myHwhcHolesMarkDup = new makerjs.models.Square(0); //孔的原点       
                  myHwhcHolesMarkDup.origin = [xd, yd];      
                  var myHwhcHolesXMarkDup = new makerjs.models.Square(0);      
                  myHwhcHolesXMarkDup.origin =[xd, yd];      
                  var myHwhcHolesYMarkDup = new makerjs.models.Square(0);      
                  myHwhcHolesYMarkDup.origin = [xd, yd];  
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkDup, new makerjs.paths.Line([0,0], [-x0, 0]));//从孔圆心出发Y方向竖向标线
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkDup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
            makerjs.model.addCaption(myHwhcHolesMarkDup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
            /*****************************************************************************/    
            makerjs.model.addPath(myHwhcHolesYMarkDup, new makerjs.paths.Line([-x0,0], [0, 0]));//Y短标线
            makerjs.model.addCaption(myHwhcHolesYMarkDup, TxtX, [-x0,0+markShift], [0, 0+markShift]);//Y文字标注
            /*****************************************************************************/ 
             //标记吊轮孔列 D位置孔下
             var myHwhcHolesDdn= new makerjs.models.Holes(d/2, [[xd+h, yd]]);
                  var myHwhcHolesMarkDdn = new makerjs.models.Square(0); //孔的原点       
                  myHwhcHolesMarkDdn.origin = [xd+h, yd];       
                  var myHwhcHolesYMarkDdn = new makerjs.models.Square(0);      
                  myHwhcHolesYMarkDdn.origin = [xd+h, yd];  
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkDdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
            makerjs.model.addCaption(myHwhcHolesMarkDdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
            /*****************************************************************************/   
            makerjs.model.addPath(myHwhcHolesYMarkDdn, new makerjs.paths.Line([-h,0], [0, 0]));//Y短标线
            makerjs.model.addCaption(myHwhcHolesYMarkDdn, TxtH, [-h,0+markShift], [0, 0+markShift]);//Y文字标注
            /*****************************************************************************/ 
            plate.models["TypeHoles_HangWheelHoleCol_Dup"+myHolesNum]=myHwhcHolesDup;
            cutPlate.models["TypeHoles_HangWheelHoleCol_Dup"+myHolesNum]=myHwhcHolesDup;
            markers.models["TypeHoles_HangWheelHoleCol_Dup"+myHolesNum]=myHwhcHolesDup;
            markers.models["TypeHoles_HangWheelHoleCol_MarkDup"+myHolesNum]=myHwhcHolesMarkDup;
            markers.models["TypeHoles_HangWheelHoleCol_XMarkDup"+myHolesNum]=myHwhcHolesXMarkDup;
            markers.models["TypeHoles_HangWheelHoleCol_YMarkDup"+myHolesNum]=myHwhcHolesYMarkDup;
            /*****************************************************************************/
            plate.models["TypeHoles_HangWheelHoleCol_Ddn"+myHolesNum]=myHwhcHolesDdn;
            cutPlate.models["TypeHoles_HangWheelHoleCol_Ddn"+myHolesNum]=myHwhcHolesDdn;
            markers.models["TypeHoles_HangWheelHoleCol_Ddn"+myHolesNum]=myHwhcHolesDdn;
            markers.models["TypeHoles_HangWheelHoleCol_MarkDdn"+myHolesNum]=myHwhcHolesMarkDdn;
            markers.models["TypeHoles_HangWheelHoleCol_YMarkDdn"+myHolesNum]=myHwhcHolesYMarkDdn;
            /*****************************************************************************/ 
              
            }else if(area==7){
            //画孔 G位置孔
                  //标记吊轮孔列G位置孔上
                  var myHwhcHolesGup= new makerjs.models.Holes(d/2, [[xg, yg]]);
                  var myHwhcHolesMarkGup = new makerjs.models.Square(0); //孔的原点       
                  myHwhcHolesMarkGup.origin = [xg, yg];      
                  var myHwhcHolesXMarkGup = new makerjs.models.Square(0);      
                  myHwhcHolesXMarkGup.origin =[xg, yg];      
                  var myHwhcHolesYMarkGup = new makerjs.models.Square(0);      
                  myHwhcHolesYMarkGup.origin = [xg, yg];  
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkGup, new makerjs.paths.Line([-x0,-y0], [-x0, -y0-markShiftFour]));//Y轴加长标线
            makerjs.model.addPath(myHwhcHolesMarkGup, new makerjs.paths.Line([0,0], [-x0-markShiftThree, 0]));//从孔圆心出发X方向横向标线
            makerjs.model.addPath(myHwhcHolesMarkGup, new makerjs.paths.Line([-x0,-y0], [-x0-markShiftThree, -y0]));//X轴加长标线
            makerjs.model.addPath(myHwhcHolesMarkGup, new makerjs.paths.Line([0,0], [0, -y0-markShiftFour]));//从孔圆心出发Y方向竖向标线
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkGup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
            makerjs.model.addCaption(myHwhcHolesMarkGup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
            /*****************************************************************************/   
            makerjs.model.addPath(myHwhcHolesXMarkGup, new makerjs.paths.Line([0,-y0-markShiftTwo], [-x0, -y0-markShiftTwo]));//X短标线
            makerjs.model.addCaption(myHwhcHolesXMarkGup, TxtX, [-x0,-y0-markShiftFour], [0, -y0-markShiftFour]);//X文字标注
            /*****************************************************************************/     
            makerjs.model.addPath(myHwhcHolesYMarkGup, new makerjs.paths.Line([-x0-markShift,-y0], [-x0-markShift, 0]));//Y短标线
            makerjs.model.addCaption(myHwhcHolesYMarkGup, TxtY, [-x0-markShiftThree,-y0], [-x0-markShiftThree, 0]);//Y文字标注
            /*****************************************************************************/ 
             //标记吊轮孔列 G位置孔下
             var myHwhcHolesGdn= new makerjs.models.Holes(d/2, [[xg+h, yg]]);
                  var myHwhcHolesMarkGdn = new makerjs.models.Square(0); //孔的原点       
                  myHwhcHolesMarkGdn.origin = [xg+h, yg];       
                  var myHwhcHolesYMarkGdn = new makerjs.models.Square(0);      
                  myHwhcHolesYMarkGdn.origin = [xg+h, yg];  
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkGdn, new makerjs.paths.Line([0,0], [0, -y0]));//从孔圆心出发X方向横向标线
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkGdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
            makerjs.model.addCaption(myHwhcHolesMarkGdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
            /*****************************************************************************/   
            makerjs.model.addPath(myHwhcHolesYMarkGdn, new makerjs.paths.Line([-h,0], [0, 0]));//Y短标线
            makerjs.model.addCaption(myHwhcHolesYMarkGdn, TxtH, [-h,0+markShift], [0, 0+markShift]);//Y文字标注
            /*****************************************************************************/ 
            plate.models["TypeHoles_HangWheelHoleCol_Gup"+myHolesNum]=myHwhcHolesGup;
            cutPlate.models["TypeHoles_HangWheelHoleCol_Gup"+myHolesNum]=myHwhcHolesGup;
            markers.models["TypeHoles_HangWheelHoleCol_Gup"+myHolesNum]=myHwhcHolesGup;
            markers.models["TypeHoles_HangWheelHoleCol_MarkGup"+myHolesNum]=myHwhcHolesMarkGup;
            markers.models["TypeHoles_HangWheelHoleCol_XMarkGup"+myHolesNum]=myHwhcHolesXMarkGup;
            markers.models["TypeHoles_HangWheelHoleCol_YMarkGup"+myHolesNum]=myHwhcHolesYMarkGup;
            /*****************************************************************************/
            plate.models["TypeHoles_HangWheelHoleCol_Gdn"+myHolesNum]=myHwhcHolesGdn;
            cutPlate.models["TypeHoles_HangWheelHoleCol_Gdn"+myHolesNum]=myHwhcHolesGdn;
            markers.models["TypeHoles_HangWheelHoleCol_Gdn"+myHolesNum]=myHwhcHolesGdn;
            markers.models["TypeHoles_HangWheelHoleCol_MarkGdn"+myHolesNum]=myHwhcHolesMarkGdn;
            markers.models["TypeHoles_HangWheelHoleCol_YMarkGdn"+myHolesNum]=myHwhcHolesYMarkGdn;
            /*****************************************************************************/ 
              
            }
  }else{      
      console.log("短边在X轴￥￥￥￥￥");
      if(area==1){
            //画孔 A位置孔
                  //标记吊轮孔列 A位置孔上
                  var myHwhcHolesAup= new makerjs.models.Holes(d/2, [[xa, ya]]);
                  var myHwhcHolesMarkAup = new makerjs.models.Square(0); //孔的原点       
                  myHwhcHolesMarkAup.origin = [xa, ya];      
                  var myHwhcHolesXMarkAup = new makerjs.models.Square(0);      
                  myHwhcHolesXMarkAup.origin =[xa, ya];      
                  var myHwhcHolesYMarkAup = new makerjs.models.Square(0);      
                  myHwhcHolesYMarkAup.origin = [xa, ya];  
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkAup, new makerjs.paths.Line([-x0,y0], [-x0, y0+markShiftTwo]));//Y轴加长标线
            makerjs.model.addPath(myHwhcHolesMarkAup, new makerjs.paths.Line([0,0], [-x0-markShiftThree, 0]));//从孔圆心出发X方向横向标线
            makerjs.model.addPath(myHwhcHolesMarkAup, new makerjs.paths.Line([-x0,y0], [-x0-markShiftThree, y0]));//X轴加长标线
            makerjs.model.addPath(myHwhcHolesMarkAup, new makerjs.paths.Line([0,0], [0, y0+markShiftTwo]));//从孔圆心出发Y方向竖向标线
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkAup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
            makerjs.model.addCaption(myHwhcHolesMarkAup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
            /*****************************************************************************/   
            makerjs.model.addPath(myHwhcHolesXMarkAup, new makerjs.paths.Line([0,y0+markShift], [-x0, y0+markShift]));//X短标线
            makerjs.model.addCaption(myHwhcHolesXMarkAup, TxtX, [-x0,y0+markShiftTwo], [0, y0+markShiftTwo]);//X文字标注
            /*****************************************************************************/     
            makerjs.model.addPath(myHwhcHolesYMarkAup, new makerjs.paths.Line([-x0-markShiftTwo,0], [-x0-markShiftTwo, y0]));//Y短标线
            makerjs.model.addCaption(myHwhcHolesYMarkAup, TxtY, [-x0-markShiftThree,0], [-x0-markShiftThree, y0]);//Y文字标注
            /*****************************************************************************/ 
             //标记吊轮孔列 A位置孔下
             var myHwhcHolesAdn= new makerjs.models.Holes(d/2, [[xa, ya-h]]);
                  var myHwhcHolesMarkAdn = new makerjs.models.Square(0); //孔的原点       
                  myHwhcHolesMarkAdn.origin = [xa, ya-h];       
                  var myHwhcHolesYMarkAdn = new makerjs.models.Square(0);      
                  myHwhcHolesYMarkAdn.origin = [xa, ya-h];  
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkAdn, new makerjs.paths.Line([0,0], [0, y0]));//从孔圆心出发X方向横向标线
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkAdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
            makerjs.model.addCaption(myHwhcHolesMarkAdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
            /*****************************************************************************/   
            makerjs.model.addPath(myHwhcHolesYMarkAdn, new makerjs.paths.Line([0,0], [0, h]));//Y短标线
            makerjs.model.addCaption(myHwhcHolesYMarkAdn, TxtH, [-markShift,0], [-markShift,h]);//Y文字标注
            /*****************************************************************************/ 
            plate.models["TypeHoles_HangWheelHoleCol_Aup"+myHolesNum]=myHwhcHolesAup;
            cutPlate.models["TypeHoles_HangWheelHoleCol_Aup"+myHolesNum]=myHwhcHolesAup;
            markers.models["TypeHoles_HangWheelHoleCol_Aup"+myHolesNum]=myHwhcHolesAup;
            markers.models["TypeHoles_HangWheelHoleCol_MarkAup"+myHolesNum]=myHwhcHolesMarkAup;
            markers.models["TypeHoles_HangWheelHoleCol_XMarkAup"+myHolesNum]=myHwhcHolesXMarkAup;
            markers.models["TypeHoles_HangWheelHoleCol_YMarkAup"+myHolesNum]=myHwhcHolesYMarkAup;
            /*****************************************************************************/
            plate.models["TypeHoles_HangWheelHoleCol_Adn"+myHolesNum]=myHwhcHolesAdn;
            cutPlate.models["TypeHoles_HangWheelHoleCol_Adn"+myHolesNum]=myHwhcHolesAdn;
            markers.models["TypeHoles_HangWheelHoleCol_Adn"+myHolesNum]=myHwhcHolesAdn;
            markers.models["TypeHoles_HangWheelHoleCol_MarkAdn"+myHolesNum]=myHwhcHolesMarkAdn;
            markers.models["TypeHoles_HangWheelHoleCol_YMarkAdn"+myHolesNum]=myHwhcHolesYMarkAdn;
            /*****************************************************************************/ 
               
            }else if(area==2){
            //画孔 D位置孔
                  //标记吊轮孔列D位置孔上
                  var myHwhcHolesBup= new makerjs.models.Holes(d/2, [[xb, yb]]);
                  var myHwhcHolesMarkBup = new makerjs.models.Square(0); //孔的原点       
                  myHwhcHolesMarkBup.origin = [xb, yb];      
                  var myHwhcHolesXMarkBup = new makerjs.models.Square(0);      
                  myHwhcHolesXMarkBup.origin =[xb, yb];      
                  var myHwhcHolesYMarkBup = new makerjs.models.Square(0);      
                  myHwhcHolesYMarkBup.origin = [xb, yb];  
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkBup, new makerjs.paths.Line([0,0], [-x0, 0]));//从孔圆心出发Y方向竖向标线
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkBup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
            makerjs.model.addCaption(myHwhcHolesMarkBup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
            /*****************************************************************************/    
            makerjs.model.addPath(myHwhcHolesYMarkBup, new makerjs.paths.Line([0,0], [0, y0]));//Y短标线
            makerjs.model.addCaption(myHwhcHolesYMarkBup, TxtY, [-markShift,0], [-markShift, y0]);//Y文字标注
            /*****************************************************************************/ 
             //标记吊轮孔列 D位置孔下
             var myHwhcHolesBdn= new makerjs.models.Holes(d/2, [[xb, yb-h]]);
                  var myHwhcHolesMarkBdn = new makerjs.models.Square(0); //孔的原点       
                  myHwhcHolesMarkBdn.origin = [xb, yb-h];       
                  var myHwhcHolesYMarkBdn = new makerjs.models.Square(0);      
                  myHwhcHolesYMarkBdn.origin = [xb, yb-h];  
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkBdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
            makerjs.model.addCaption(myHwhcHolesMarkBdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
            /*****************************************************************************/   
            makerjs.model.addPath(myHwhcHolesYMarkBdn, new makerjs.paths.Line([0,0], [0, h]));//Y短标线
            makerjs.model.addCaption(myHwhcHolesYMarkBdn, TxtH, [-markShift,0], [-markShift, h]);//Y文字标注
            /*****************************************************************************/ 
            plate.models["TypeHoles_HangWheelHoleCol_Bup"+myHolesNum]=myHwhcHolesBup;
            cutPlate.models["TypeHoles_HangWheelHoleCol_Bup"+myHolesNum]=myHwhcHolesBup;
            markers.models["TypeHoles_HangWheelHoleCol_Bup"+myHolesNum]=myHwhcHolesBup;
            markers.models["TypeHoles_HangWheelHoleCol_MarkBup"+myHolesNum]=myHwhcHolesMarkBup;
            markers.models["TypeHoles_HangWheelHoleCol_XMarkBup"+myHolesNum]=myHwhcHolesXMarkBup;
            markers.models["TypeHoles_HangWheelHoleCol_YMarkBup"+myHolesNum]=myHwhcHolesYMarkBup;
            /*****************************************************************************/
            plate.models["TypeHoles_HangWheelHoleCol_Bdn"+myHolesNum]=myHwhcHolesBdn;
            cutPlate.models["TypeHoles_HangWheelHoleCol_Bdn"+myHolesNum]=myHwhcHolesBdn;
            markers.models["TypeHoles_HangWheelHoleCol_Bdn"+myHolesNum]=myHwhcHolesBdn;
            markers.models["TypeHoles_HangWheelHoleCol_MarkBdn"+myHolesNum]=myHwhcHolesMarkBdn;
            markers.models["TypeHoles_HangWheelHoleCol_YMarkBdn"+myHolesNum]=myHwhcHolesYMarkBdn;
            /*****************************************************************************/ 
              
            }else if(area==3){
            //画孔 C位置孔
                  //标记吊轮孔列C位置孔上
                  var myHwhcHolesCup= new makerjs.models.Holes(d/2, [[xc, yc]]);
                  var myHwhcHolesMarkCup = new makerjs.models.Square(0); //孔的原点       
                  myHwhcHolesMarkCup.origin = [xc, yc];      
                  var myHwhcHolesXMarkCup = new makerjs.models.Square(0);      
                  myHwhcHolesXMarkCup.origin =[xc, yc];      
                  var myHwhcHolesYMarkCup = new makerjs.models.Square(0);      
                  myHwhcHolesYMarkCup.origin = [xc, yc];  
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkCup, new makerjs.paths.Line([x0,y0], [x0, y0+markShiftFour]));//Y轴加长标线
            makerjs.model.addPath(myHwhcHolesMarkCup, new makerjs.paths.Line([0,0], [x0+markShiftThree, 0]));//从孔圆心出发X方向横向标线
            makerjs.model.addPath(myHwhcHolesMarkCup, new makerjs.paths.Line([x0,y0], [x0+markShiftThree, y0]));//X轴加长标线
            makerjs.model.addPath(myHwhcHolesMarkCup, new makerjs.paths.Line([0,0], [0, y0+markShiftFour]));//从孔圆心出发Y方向竖向标线
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkCup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
            makerjs.model.addCaption(myHwhcHolesMarkCup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
            /*****************************************************************************/   
            makerjs.model.addPath(myHwhcHolesXMarkCup, new makerjs.paths.Line([0,y0+markShiftTwo], [x0, y0+markShiftTwo]));//X短标线
            makerjs.model.addCaption(myHwhcHolesXMarkCup, TxtX, [0,y0+markShiftFour], [x0, y0+markShiftFour]);//X文字标注
            /*****************************************************************************/     
            makerjs.model.addPath(myHwhcHolesYMarkCup, new makerjs.paths.Line([x0+markShift,y0], [x0+markShift, 0]));//Y短标线
            makerjs.model.addCaption(myHwhcHolesYMarkCup, TxtY, [x0+markShiftThree,0], [x0+markShiftThree, y0]);//Y文字标注
            /*****************************************************************************/ 
             //标记吊轮孔列 C位置孔下
             var myHwhcHolesCdn= new makerjs.models.Holes(d/2, [[xc, yc-h]]);
                  var myHwhcHolesMarkCdn = new makerjs.models.Square(0); //孔的原点       
                  myHwhcHolesMarkCdn.origin = [xc, yc-h];       
                  var myHwhcHolesYMarkCdn = new makerjs.models.Square(0);      
                  myHwhcHolesYMarkCdn.origin = [xc, yc-h];  
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkCdn, new makerjs.paths.Line([0,0], [0, y0]));//从孔圆心出发X方向横向标线
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhcHolesMarkCdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
            makerjs.model.addCaption(myHwhcHolesMarkCdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
            /*****************************************************************************/   
            makerjs.model.addPath(myHwhcHolesYMarkCdn, new makerjs.paths.Line([0,0], [0, h]));//Y短标线
            makerjs.model.addCaption(myHwhcHolesYMarkCdn, TxtH, [-markShift,0], [-markShift, h]);//Y文字标注
            /*****************************************************************************/ 
            plate.models["TypeHoles_HangWheelHoleCol_Cup"+myHolesNum]=myHwhcHolesCup;
            cutPlate.models["TypeHoles_HangWheelHoleCol_Cup"+myHolesNum]=myHwhcHolesCup;
            markers.models["TypeHoles_HangWheelHoleCol_Cup"+myHolesNum]=myHwhcHolesCup;
            markers.models["TypeHoles_HangWheelHoleCol_MarkCup"+myHolesNum]=myHwhcHolesMarkCup;
            markers.models["TypeHoles_HangWheelHoleCol_XMarkCup"+myHolesNum]=myHwhcHolesXMarkCup;
            markers.models["TypeHoles_HangWheelHoleCol_YMarkCup"+myHolesNum]=myHwhcHolesYMarkCup;
            /*****************************************************************************/
            plate.models["TypeHoles_HangWheelHoleCol_Cdn"+myHolesNum]=myHwhcHolesCdn;
            cutPlate.models["TypeHoles_HangWheelHoleCol_Cdn"+myHolesNum]=myHwhcHolesCdn;
            markers.models["TypeHoles_HangWheelHoleCol_Cdn"+myHolesNum]=myHwhcHolesCdn;
            markers.models["TypeHoles_HangWheelHoleCol_MarkCdn"+myHolesNum]=myHwhcHolesMarkCdn;
            markers.models["TypeHoles_HangWheelHoleCol_YMarkCdn"+myHolesNum]=myHwhcHolesYMarkCdn;
            /*****************************************************************************/ 
              
            }
  }
  

myHolesNum++;
return{plate,cutPlate, markers,myHolesNum}
};


export default HangWheelHoleCol;